import styled from "styled-components";

export const Profile = styled.div`
  width: 100%;
  height: 100%;
  max-width: 800px;
  margin: auto;
  padding: 1rem 0.7rem;
`;

export const UserDescription = styled.div`
  margin-top: 2rem;
  color: white;
  padding-bottom: 2rem;
  border-bottom: 0.2px solid #565656;
`;

export const PostWrapper = styled.div`
  padding-bottom: 1rem;
`;

export const ProfileEditWrapper = styled.div`
  width: 800px;
  max-width: 90%;
  padding: 2rem 2rem calc(10rem + env(safe-area-inset-bottom, 0px));
  margin: 2rem auto;
  position: relative;

  @media screen and (max-width: 768px) {
    max-width: calc(100% - 2rem);
    padding: 1rem 0 calc(11rem + env(safe-area-inset-bottom, 0px));
    margin-top: 0;
  }

  .profile-img-upload {
    span {
      top: 0;
    }
  }


  .section-two {
    margin-top: 0;
  }

  .section-two > div:first-child {
    align-items: center;
    gap: 1rem;
  }

  .profile-img-box {
    bottom: auto !important;
    margin-top: -64px;
    flex: none;
  }

  .profile-img-box + div {
    min-width: 0;
    padding-bottom: 0.75rem;
  }

  .profile-img-box + div h1 {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.2;
  }

  .count-span {
    line-height: 1;
  }

  @media screen and (max-width: 640px) {
    .section-two > div:first-child {
      align-items: center;
      flex-direction: row;
      gap: 0.75rem;
    }

    .section-two > div:first-child > div:first-child {
      flex: 1 1 auto;
      min-width: 0;
      gap: 0.75rem;
    }

    .section-two > div:first-child > div:last-child {
      align-self: center;
      margin-top: 0;
    }

    .profile-img-box {
      margin-top: -48px;
    }

    .profile-img-box + div {
      padding-bottom: 0;
      padding-top: 0.25rem;
    }
  }

  .profile-edit-form {
    textarea {
      border: none;
      outline: none;
      box-shadow: none !important;
      background-color: black;
      color: #ffffff;
      border-bottom: 1px solid #8f8f8f;
      border-radius: 0;
      font-size: 1;
      padding-left: 0;
      padding-top: 1rem;
      &::placeholder {
        color: rgba(255, 255, 255, 0.7);
      }
      &::active {
        box-shadow: none !important;
      }
    }
  }
`;

export const ProfileImage = styled.img`
  width: 150px;
  height: 150px;
  margin: auto;
  border-radius: 50%;
  overflow: hidden;
  object-fit: cover;
  background: white;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
`;

export const ImageButton = styled.button`
  width: fit-content;
  background: transparent;
  margin: auto;
  font-weight: 400;
`;

export const AddIntroPost = styled.div``;
export const CardFrame = styled.img`
  width: 15%;
  margin: 15px 0;
`;

export const FormWrapper = styled.div`
  margin-top: 2rem;
  position: relative;
  bottom: 0;

  .update-profile-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    width: fit-content;
    margin: 0;
    padding: 0.6rem 1.9rem;
    border-radius: 50px;
    background: #ffffff;
    border: 1px solid #ffffff;
    color: #000000;
    cursor: pointer;
    font-weight: 600;
    line-height: 1;
    transition:
      background-color 0.2s ease,
      color 0.2s ease,
      border-color 0.2s ease;

    &:hover,
    &:focus-visible {
      background-color: #ffffff;
      border-color: #ffffff;
      color: #000000;
    }
  }
`;

export const Description = styled.div`
  color: #ffffff;
  font-size: 17px;
  margin-top: 0.4rem;
  margin-bottom: 1rem;
  span {
    font-weight: 500;
  }
  padding: 1rem;
`;

export const Post = styled.div`
  /* width: 600px; */
  width: 100%;
  margin-bottom: 4rem;
`;
export const ContactRow = styled.div`
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  align-items: center;
  gap: 0.75rem;

  @media screen and (max-width: 420px) {
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 0.6rem;
  }
`;

export const ContactSelector = styled.select`
  width: 100%;
  height: 2rem;
  border: 0;
  border-bottom: 1px solid #8f8f8f;
  border-radius: 0;
  background: #000000;
  color: #ffffff;
  outline: none;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  line-height: 1.4;
`;
